module.exports = __webpack_public_path__ + "img/import-active.991d5c10.svg";